import React, { useEffect, useState } from 'react';
import { isUndefined } from 'lodash';
import { func, object, string } from 'prop-types';
import ChartPanel from '../../../../ui-components/chart-panel/chart-panel.jsx';
import { CHART_TYPE } from '../../../../ui-components/chart-wrapper/chart-constants.js';
import {
   DAILY_WEEKLY_TOGGLE_TAB,
   computeData,
   getFromToDate,
   generateDatesBetween,
} from '../charts-util.js';
import { getTacticalChartConfig } from './chart-recommendation-tactical-config.js';

const ChartRecommendationTactical = ({
   filteredTacticalSummaryData,
   searchCriteriaPayload,
   recommendationStatus,
   updateFilteredTacticalSummaryData,
   barOnClickHandler = () => {},
   gridChartIconOnClickHandler = () => {},
   filterBy,
}) => {
   const [barChart, setBarChart] = useState([]);
   const [dailyWeeklyTabValue, setDailyWeeklyTabValue] = useState(
      DAILY_WEEKLY_TOGGLE_TAB.DAILY
   );

   const fromTo = getFromToDate(searchCriteriaPayload);
   const datesInSequence = generateDatesBetween(fromTo);

   const handleDailyWeeklyTabOnClick = (value) => {
      setDailyWeeklyTabValue(value);
   };

   useEffect(() => {
      setBarChart(
         computeData(
            filteredTacticalSummaryData,
            recommendationStatus,
            datesInSequence,
            dailyWeeklyTabValue,
            filterBy
         )
      );
   }, [filteredTacticalSummaryData]);

   useEffect(() => {
      setDailyWeeklyTabValue(DAILY_WEEKLY_TOGGLE_TAB.DAILY);
      updateFilteredTacticalSummaryData(recommendationStatus);
   }, [recommendationStatus]);

   useEffect(() => {
      setBarChart(
         computeData(
            filteredTacticalSummaryData,
            recommendationStatus,
            datesInSequence,
            dailyWeeklyTabValue,
            filterBy
         )
      );
   }, [dailyWeeklyTabValue]);

   const tacticalChartConfig = getTacticalChartConfig(
      recommendationStatus,
      filteredTacticalSummaryData,
      dailyWeeklyTabValue,
      barOnClickHandler,
      handleDailyWeeklyTabOnClick
   );

   return (
      <ChartPanel
         key={tacticalChartConfig.chartKey}
         chartType={CHART_TYPE.BAR_CHART}
         isLoading={isUndefined(filteredTacticalSummaryData)}
         chartData={barChart}
         configChart={tacticalChartConfig}
         toolbarConfig={{
            isShowToolbar: true,
            gridChartIconOnClickHandler: gridChartIconOnClickHandler,
         }}
         apiErrorMessage={false}
      ></ChartPanel>
   );
};

ChartRecommendationTactical.propTypes = {
   searchCriteriaPayload: object.isRequired,
   recommendationStatus: string,
   barOnClickHandler: func,
   legendOnClickHandler: func,
};

export default ChartRecommendationTactical;
